import { Button, Grid } from '@material-ui/core';
import React from 'react';
import { useTranslate } from 'react-admin';

import { InfoBox } from './InfoBox';

interface EditControlsProps {
  onUndo: () => void;
  onRedo: () => void;
  canUndo: boolean;
  canRedo: boolean;
}

export const EditControls: React.FC<EditControlsProps> = ({
  onUndo,
  onRedo,
  canUndo,
  canRedo,
}) => {
  const translate = useTranslate();
  return (
    <InfoBox title={translate('osfc.storage_ui.edit.title')} style={{ marginBottom: "15px" }}>
      <Grid container spacing={1}>
        <Grid item xs={6}>
          <Button
            onClick={onUndo}
            disabled={!canUndo}
            variant="contained"
            color="secondary"
            fullWidth
          >
            {translate('osfc.storage_ui.edit.undo')}
          </Button>
        </Grid>
        <Grid item xs={6}>
          <Button
            onClick={onRedo}
            disabled={!canRedo}
            variant="contained"
            color="secondary"
            fullWidth
          >
            {translate('osfc.storage_ui.edit.redo')}
          </Button>
        </Grid>
      </Grid>
    </InfoBox>
  );
};
